'use strict';

module.exports = function hslaRegex(options) {
  options = options || {};

  return options.exact ?
    /^hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*(\d*(?:\.\d+)?)\)$/ :
    /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*(\d*(?:\.\d+)?)\)/ig;
}



//////////////////
// WEBPACK FOOTER
// ./dev/stylist_parent/functions/postcss/css-shorthand-expand/node_modules/hsla-regex/index.js
// module id = 589
// module chunks = 0